module.exports = __webpack_public_path__ + "static/media/hot42.f9ab22f5.jpg";